import React, { useEffect, createElement } from 'react';
const ShopilotsWidget = () => {
  useEffect(() => {
    // Create and append the Shopilots widget script
    const customerId = 'ShoPilots AI';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://api-test.shopilots.com/api/v1/widget?customer_id=${customerId}`;
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
    // Initialize window.shopilots if it doesn't exist
    if (!window.shopilots) {
      window.shopilots = {};
    }
    // Cleanup function to remove script when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return null;
};
export default ShopilotsWidget;